import { render, staticRenderFns } from "./Viphosts_list.vue?vue&type=template&id=1db70253&scoped=true&"
import script from "./Viphosts_list.vue?vue&type=script&lang=js&"
export * from "./Viphosts_list.vue?vue&type=script&lang=js&"
import style0 from "./Viphosts_list.vue?vue&type=style&index=0&id=1db70253&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db70253",
  null
  
)

export default component.exports